import LimitsUsageServices from './LimitsUsageServices';
import LimitsUsageServicesMock from './LimitsUsageServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? LimitsUsageServicesMock : LimitsUsageServices;
